import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Message } from 'primereact/message';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import { storeService } from 'services/store.service';
import { showTostify } from 'utils/interfaces';
import { routes } from 'utils/routes';
import { useNavigate } from 'react-router-dom';
import { Calendar } from 'primereact/calendar';
import CustomToast from 'views/components/form-inputs/alert';
import { categoryService } from 'services/categories.service';
import { Card } from 'primereact/card';
import { Chip } from 'primereact/chip';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Fieldset } from 'primereact/fieldset';

import './style.scss';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';

const PromocodeValidate = () => {
	const [loading, setLoading] = useState(false);
	const [categories, setCategories] = useState<any>([]);
console.log(categories);

	const stepperRef = useRef<any>(null);
	const toastRef = useRef<any>(null);

	const navigation = useNavigate()

	const formik: any = useFormik({
		initialValues: {
			title: "",
			phone_number1: "",
			// phone_number2: "",
			email: "",
			type: "",
			state: "",
			city: "",
			address1: "",
			address2: "",
			postcode: "",
			landmark: "",
			category_id: "",
			sub_category: "",
			terms_conditions: "",
			help: "",
			about: "",
			description: "",
			country: "",
			seo_title: "",
			seo_keywords: "",
			seo_description: "",
			hashtags: "",
			user: {
				first_name: '',
				last_name: '',
				phone_number1: '',
				gender: '',
				email: '',
				username: '',
				password: '',
			},
			deal: {
				title: '',
				description: '',
				type: '',
				payment_type: '',
				discount_code: '',
				status: 'active',
				start_date: "",
				end_date: "",
				amount: ''
			},
		},
		validationSchema: Yup.object({
			title: Yup.string().required('Store Name is required'),
			phone_number1: Yup.string().required('Phone number is required'),
			email: Yup.string().email('Invalid email format').required('Email is required'),
			type: Yup.string().required('Type is required'),
			state: Yup.string().required('State is required'),
			city: Yup.string().required('City is required'),
			category_id: Yup.string().required('Category is required'),
			sub_category: Yup.string().required('Subcategory is required'),
			terms_conditions: Yup.string().required('Terms and conditions are required'),
			help: Yup.string().required('Help information is required'),
			about: Yup.string().required('About information is required'),
			user: Yup.object().shape({
				first_name: Yup.string().required('First name is required'),
				last_name: Yup.string().required('Last name is required'),
				phone_number1: Yup.string().required('User phone number is required'),
				gender: Yup.string().required('Gender is required'),
				email: Yup.string().email('Invalid email format').required('User email is required'),
				username: Yup.string().required('Username is required'),
				password: Yup.string().required('Password is required'),
			}),
			deal: Yup.object().shape({
				title: Yup.string().required('Deal title is required'),
				description: Yup.string().required('Description is required'),
				type: Yup.string().required('Deal type is required'),
				amount: Yup.string().required('Amount is required'),
				payment_type: Yup.string().required('Payment type is required'),
				discount_code: Yup.string().required('Discount code is required'),
				status: Yup.string().required('Status is required'),
				start_date: Yup.date().required('Start date is required'),
				end_date: Yup.date().required('End date is required'),
			}),
		}),

		onSubmit: async (values: any) => {
			setLoading(true);
			try {
				const data = await storeService.createStore(values);

				if (data.error === false) {
					showTostify(toastRef, 'success', data.message);
					navigation(routes.stores)
				} else {
					showTostify(toastRef, 'error', data.message);
				}
			} catch (err: any) {
				showTostify(toastRef, 'error', err.message);
			} finally {
				setLoading(false);
			}
		},
	});

	// const handleStateChange = (e: any) => {
	// 	const selectedStateId = e.value;
	// 	formik.setFieldValue('state', selectedStateId);

	// 	const selectedState: any = statesData.states.find(state => state.label === selectedStateId);
	// 	if (selectedState) {
	// 		setCities(selectedState.cities);
	// 		formik.setFieldValue('city', '');
	// 	} else {
	// 		setCities([]);
	// 	}
	// };

	useEffect(() => {
		categoryService.getCategories().then((data) => {
			setCategories(data.items)
		})
	}, [])

	const home = { icon: 'pi pi-arrow-left', url: 'https://primereact.org' }

	const NewStoreMenu = [
		{ label: 'Local Store' },
		{ label: 'Add New Store' }
	];

	const [value2, setValue2] = useState<number>(0); // Initial state set to a number
	const [date, setDate] = useState(null);


	return (
		<>

			<section className='shopkeeper-page mt-2'>
				<div className="container">
					<div style={{ width: "800px" }}>
						<div className="grid">
							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Customer Name</label>
									<InputNumber
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Gross Amount</label>
									<InputNumber
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Customer Number</label>
									<InputNumber
										onValueChange={(e: any) => setValue2(e.value)}
										useGrouping={false}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Discount</label>
									<InputNumber
										onValueChange={(e: any) => setValue2(e.value)}
										useGrouping={false}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Email</label>
									<InputNumber
										onValueChange={(e: any) => setValue2(e.value)}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="type">Coin Used</label>
									<Dropdown
										showClear
										id="type"
										name="type"
										value={formik.values?.type}
										onChange={(e) => formik.setFieldValue('type', e.value)}
										options={[
											{ label: 'Standard', value: 'standard' },
											{ label: 'Gift voucher', value: 'gift_voucher' },
											{ label: 'Exclusive', value: 'exclusive' },
										]}
										placeholder="Select option"
										className="w-full"
									/>
									{formik.touched?.type && formik.errors?.type && (
										<Message severity="error" text={formik.errors?.type} />
									)}
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Store Name</label>
									<InputNumber
										onValueChange={(e: any) => setValue2(e.value)}
										useGrouping={false}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Net Amount</label>
									<InputNumber
										onValueChange={(e: any) => setValue2(e.value)}
										useGrouping={false}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Deal</label>
									<InputNumber
										onValueChange={(e: any) => setValue2(e.value)}
										useGrouping={false}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Payment Mode</label>
									<InputNumber
										onValueChange={(e: any) => setValue2(e.value)}
										useGrouping={false}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="last_name">Store Help</label>
									<InputTextarea
										rows={5}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-3">
									<label htmlFor="last_name">Reference Number</label>
									<InputNumber
										onValueChange={(e: any) => setValue2(e.value)}
										useGrouping={false}
										placeholder="Enter here"
										className='w-full'
									/>
								</div>

								<div className="form-group mb-2">
									<label htmlFor="last_name">Upload Screenshot</label>
									<FileUpload
										className='select-file'
										mode="basic"
										name="demo[]"
										url="/api/upload"
										accept="image/*"
										chooseLabel="Select File"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className='shopkeeper-page border-primary-color border-top-1 py-4' style={{ backgroundColor: "#fff" }}>
				<div className="container">
					<div className="grid mx-0 mb-3 p-2 pb-1 border-1 border-primary-color border-round" style={{ backgroundColor: "#3139570D" }}>
						<div className="col">
							<div className="form-group mb-2">
								<label htmlFor="last_name">Inventory Name</label>
								<InputText
									id="first_name"
									name="first_name"
									value={formik.values.first_name}
									placeholder="Enter here"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
								/>
							</div>
						</div>

						<div className="col">
							<div className="form-group mb-2">
								<label htmlFor="last_name">Code</label>
								<InputText
									id="first_name"
									name="first_name"
									value={formik.values.first_name}
									placeholder="Enter here"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
								/>
							</div>
						</div>

						<div className="flex align-items-end p-2">
							<Button icon="pi pi-plus" rounded severity="danger" className='mb-2 p-2 min-h-0 h-2rem w-2rem	' />
						</div>
					</div>

					<div className="promocode-list grid mx-0 mb-3 p-2 pb-1 border-1 border-primary-color border-round">
						<div className="col">
							<h4 className='m-0'>Movie Coupon</h4>
						</div>

						<div className="col">
							<p className='m-0'>DRFGTESDF</p>
						</div>

						<div className="col flex justify-content-end">
							<Button link icon="pi pi-trash" className='p-0 min-h-0' />
						</div>
					</div>

					<div className="promocode-list grid mx-0 mb-3 p-2 pb-1 border-1 border-primary-color border-round">
						<div className="col">
							<h4 className='m-0'>Gift Voucher</h4>
						</div>

						<div className="col">
							<p className='m-0'>GIFTVOUCHER123</p>
						</div>

						<div className="col flex justify-content-end">
							<Button link icon="pi pi-trash" className='p-0 min-h-0' />
						</div>
					</div>

					<div className="col-5 mt-8 mx-auto">
						<Button label="GIve Services" className='primary w-full' />
					</div>
				</div>
			</section>

			<section className='new-store-menu-wrap bg-white border-bottom-1 border-primary-color flex justify-content-center align-items-center mb-3'>
				<div style={{ width: "800px" }}>
					<div className='flex justify-content-between align-items-center h-full' >
						<BreadCrumb
							model={NewStoreMenu}
							home={home}
							className='new-store-menu border-0 border-noround'
						/>
					</div>

					<Card className='promocode-validate shadow-none border-bottom-1 border-primary-color'>
						<form className="flex align-items-end justify-content-center gap-2">
							<div className="form-group mb-0">
								<label htmlFor="username1">Enter Promocode</label>
								<InputText
									id="email"
									name="email"
									placeholder="MYNTRA500"
								/>
							</div>
							<div className="form-group mb-0">
								<label htmlFor="username1">Enter Username</label>
								<InputText
									id="email"
									name="email"
									placeholder="Jonathan Basett"
								/>
							</div>
							<Button label="Check" className='primary' />
						</form>
						<Chip label="This Promocode is Already Used" className="custom-chip dander-chip already-used mt-2" />
					</Card>
				</div>
			</section>

			<section className='shopkeeper-page'>
				<div className="container">
					<Card className='check-deals-code shadow-none border-bottom-1 border-primary-color'>
						<form className="flex align-items-end justify-content-center gap-2">
							<div className="form-group mb-0">
								<label htmlFor="username1">Check Deals Code</label>
								<InputText
									id="email"
									name="email"
									placeholder="MYNTRA500"
								// value={formik.values.email}
								// onChange={formik.handleChange}
								// onBlur={formik.handleBlur}
								// required
								// className={formik.touched.email && formik.errors.email ? 'p-invalid' : ''}
								/>
							</div>
							<Button label="Check" className='primary' />
						</form>
					</Card>

					<Card className='deals-code shadow-none mt-4'>
						<div className="flex align-items-center justify-content-between gap-2 mb-3">
							<div>
								<Chip label="MYNTRA500" className="custom-chip" />
								<Chip label="Paid" icon="pi pi-shopping-bag" className="chip-paid bg-transparent" />
								<Chip label="Already Used" className="custom-chip already-used" />
							</div>

							<Chip label="Valid till 10th Oct, 24" icon="pi pi-clock" className="bg-transparent" />
						</div>

						<div className='flex align-items-center justify-content-between'>
							<div className='w-8'>
								<h2 className='m-0 mb-2'>Big Fashion Festival</h2>
								<p className='m-0'>Myntra Big Fashion Festival is Live Now: 50% to 90% OFF + Flat Rs 500 OFF | New Users</p>
							</div>

							<Button label="Redeem Now" className='primary' disabled />
						</div>

						<Fieldset legend="More Details" toggleable className='deals-code-details'>
							<div className="grid">
								<div className='col-7'>
									<Card className='shadow-none border-1 border-primary-color'>
										<strong className='mt-0'>Myntra Big Fashion Festival is Live Now</strong>
										<ul className="p-list pl-4">
											<li>Get 50% to 90% OFF on your favourite fashion collections</li>
											<li>Flat Rs 500 OFF on orders above Rs 1899</li>
											<li>The coupon code will be applicable on Myntra APP for first-time users only</li>
											<li>Additional 10% OFF on ICICI, Kotak & Axis Bank Cards</li>
											<li>7.5% + Extra 5% Discount on Myntra Kotak Credit Card</li>
											<li>Free Shipping is available</li>
										</ul>
									</Card>
								</div>

								<div className="col-5">
									<Chip label="Redeemed on - 1st Oct, 2024 10:30 AM" className="custom-chip" />

									<ul className='user-details p-list list-none pl-2'>
										<li><strong>Customer Name:</strong> Jonathan Basett</li>
										<li><strong>ID:</strong> JB11002</li>
										<li><strong>Number:</strong> +91 12345 67890</li>
										<li><strong>Email:</strong> basett@hotmail.com</li>
									</ul>
								</div>
							</div>
						</Fieldset>
					</Card>
				</div>
			</section>

			<section className='p-add-local-store shopkeeper-page'>
				<div className="container">
					<CustomToast ref={toastRef} />
					<form onSubmit={formik.handleSubmit} className='flex flex-wrap h-full'>

						<Stepper ref={stepperRef}>
							<StepperPanel header="Store Info">
								<div className='p-local-store-header' style={{ minHeight: "120px", backgroundColor: "#959CB6", width: "100%" }}>
									<h2 className='text-center text-white pt-3 m-0'>Add Local Store</h2>
								</div>

								<div className='p-local-store flex flex-column bg-white p-3'>
									<div className='pt-5'>
										<div className="grid m-0">
											<Divider align="center" className='stores-divider m-0'>
												<div className="inline-flex align-items-center">
													<h2 className='text-center'>Store Info</h2>
												</div>
											</Divider>
											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="first_name">Store Name</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="Shopkeeper Name"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Store Number</label>
													<InputNumber
														value={value2}
														onValueChange={(e: any) => setValue2(e.value)}
														useGrouping={false}
														placeholder='+91 01234 56789'
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Category</label>
													<Dropdown
														showClear
														placeholder="Select"
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Sub Category</label>
													<Dropdown
														showClear
														placeholder="Select"
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Address</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="Address"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Pincode</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="Pincode"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">City</label>
													<Dropdown
														showClear
														placeholder="Select a City"
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">State</label>
													<Dropdown
														showClear
														placeholder="Select a State"
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12">
												<div className="form-group mb-2">
													<label htmlFor="last_name">About Store</label>
													<InputTextarea
														keyfilter="int"
														placeholder="Lorem Ipsum dolor sit amet."
														rows={3}
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Store Terms & Conditions</label>
													<InputTextarea
														keyfilter="int"
														placeholder="Lorem Ipsum dolor sit amet."
														rows={3}
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Store Help</label>
													<InputTextarea
														keyfilter="int"
														placeholder="Lorem Ipsum dolor sit amet."
														rows={3}
														className='w-full'
													/>
												</div>
											</div>

											<div className="col">
												<div className="grid mx-0 mb-2 p-2 pb-1 border-1 border-primary-color border-round" style={{ backgroundColor: "#3139570D" }}>
													<div className="col-12 md:col-6 lg:col-6">
														<div className="form-group mb-2">
															<label htmlFor="last_name">Username</label>
															<InputText
																id="first_name"
																name="first_name"
																value={formik.values.first_name}
																placeholder="Username"
																onChange={formik.handleChange}
																onBlur={formik.handleBlur}
																className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
															/>
														</div>
													</div>

													<div className="col-12 md:col-6 lg:col-6">
														<div className="form-group mb-2">
															<label htmlFor="last_name">Password</label>
															<InputText
																id="first_name"
																name="first_name"
																value={formik.values.first_name}
																placeholder="Password"
																onChange={formik.handleChange}
																onBlur={formik.handleBlur}
																className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="col-12 mt-auto">
										<div className="flex justify-content-between mb-3">
											<Button label="Prev" severity="danger" outlined className='primary' />
											<Button
												label={loading ? "Next" : "Next"}
												type="submit"
												className="primary w-8"
												disabled={!formik.isValid || formik.isSubmitting || loading}
											/>
										</div>
									</div>
								</div>
							</StepperPanel>

							<StepperPanel header="Shopkeeper Info">
								<div className='p-local-store-header' style={{ minHeight: "120px", backgroundColor: "#959CB6", width: "100%" }}>
									<h2 className='text-center text-white pt-3 m-0'>Add Local Store</h2>
								</div>

								<div className='p-local-store flex flex-column bg-white p-3'>
									<div className='pt-5'>
										<div className="grid m-0">

											<Divider align="center" className='stores-divider m-0'>
												<div className="inline-flex align-items-center">
													<h2 className='text-center'>Shopkeeper Info</h2>
												</div>
											</Divider>
											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="first_name">Shopkeeper Name</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="Shopkeeper Name"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Shopkeeper Number - 1</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="Shopkeeper Number - 1"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Email</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="Email"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Address</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="Address"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Pincode</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="Pincode"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">City</label>
													<Dropdown
														showClear
														placeholder="Select a City"
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">State</label>
													<Dropdown
														showClear
														placeholder="Select a State"
														className='w-full'
													/>
												</div>
											</div>
										</div>
									</div>

									<div className="col-12 mt-auto">
										<div className="flex justify-content-between mb-3">
											<Button label="Prev" severity="danger" outlined className='primary' />
											<Button
												label={loading ? "Next" : "Next"}
												type="submit"
												className="primary w-8"
												disabled={!formik.isValid || formik.isSubmitting || loading}
											/>
										</div>
									</div>
								</div>
							</StepperPanel>

							<StepperPanel header="Deal Info">
								<div className='p-local-store-header' style={{ minHeight: "120px", backgroundColor: "#959CB6", width: "100%" }}>
									<h2 className='text-center text-white pt-3 m-0'>Add Local Store</h2>
								</div>

								<div className='p-local-store flex flex-column bg-white p-3'>
									<div className='pt-5'>
										<div className="grid m-0">
											<Divider align="center" className='stores-divider m-0'>
												<div className="inline-flex align-items-center">
													<h2 className='text-center'>Deal Info</h2>
												</div>
											</Divider>
											<div className="col-12">
												<div className="form-group mb-2">
													<label htmlFor="first_name">Deal Title</label>
													<InputText
														id="first_name"
														name="first_name"
														value={formik.values.first_name}
														placeholder="First Name"
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														className={formik.touched.first_name && formik.errors.first_name ? 'p-invalid' : ''}
													/>
													{formik.touched.first_name && formik.errors.first_name && (
														<Message severity="error" text={formik.errors.first_name} />
													)}
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Start Date</label>
													<Calendar
														value={date}
														onChange={(e: any) => setDate(e.value)}
														showIcon
														placeholder="Select a date"
													/>
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">End Date</label>
													<Calendar
														value={date}
														onChange={(e: any) => setDate(e.value)}
														showIcon
														placeholder="Select a date"
													/>
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Deal Type</label>
													<Dropdown
														showClear
														placeholder="Normal, Exclusive, Special"
														className='w-full'
													/>
												</div>
											</div>

											<div className="col-12 md:col-6 lg:col-6">
												<div className="form-group mb-2">
													<label htmlFor="last_name">Payment Type</label>
													<Dropdown
														showClear
														placeholder="Call now, Pay now, View n..."
														className='w-full'
													/>
												</div>
											</div>
										</div>
									</div>

									<div className="col-12 mt-auto">
										<div className="flex justify-content-between mb-3">
											<Button label="Prev" severity="danger" outlined className='primary' />
											<Button
												label={loading ? "Next" : "Next"}
												type="submit"
												className="primary w-8"
												disabled={!formik.isValid || formik.isSubmitting || loading}
											/>
										</div>
									</div>
								</div>
							</StepperPanel>
						</Stepper>
					</form>
				</div>
			</section>
		</>
	);
};

export default PromocodeValidate;


